<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="eventSensorReadings-modal">
<!-- <div class="modal-content eventSensorReadings-modal"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 style="color: rgb(10, 10, 10); text-transform: none;">Evaluated timer conditions for '{{event.name}}'</h5>
    <!-- <button (click)="evaluateAndInvokeModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
      aria-hidden="true">&times;</span></button> -->
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div class="modal-body">
    <div style="font-size: 15px; height: 35px; background-color: var(--kig-section-header-bg);">
      <label style="margin-top: 7px; margin-left: 10px;">Evaluation Window</label>
    </div>
    <div>
      <br>&nbsp;&nbsp;
      From: <b>{{event.evaluateStartTime}}</b>&nbsp;&nbsp;&nbsp;
      To: <b>{{event.evaluateEndTime}}</b>&nbsp;&nbsp;&nbsp;
      Days Of Week: <b>{{event.evaluateDaysOfWeekUser}}</b>&nbsp;&nbsp;&nbsp;
      <!-- Currently: <b>{{event.evaluateActiveState}}</b> -->
    </div><br>

    <p-table #evaluateTimerEventResultsTable [columns]="evaluateTimerEventResultsCols" [value]="conditionResults" >

      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="text-center" style="background-color: var(--kig-section-header-bg);">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template let-columns="columns" let-rowData ; pTemplate="body">
        <tr>
          <td class="text-center">
            {{rowData.timerType}}
          </td>
          <td class="text-center">
            <div *ngIf="rowData.timerType=='Single'">
              {{rowData.timingSingle}}
            </div>
            <div *ngIf="rowData.timerType=='Repeat'">
              {{rowData.timingRepeat}}
            </div>
          </td>
          <td class="text-center">
            {{rowData.daysOfWeek}}
          </td>
          <td class="text-center">
            {{rowData.booleanValue}}
          </td>
          <td class="text-center">
            <div *ngIf="!isLastConditionResult(rowData.id)">
              {{rowData.logicOperator | lowercase}}
            </div>
          </td>
        </tr>

      </ng-template>
    </p-table>

    <!-- <div class="pull-right" style="font-size: medium;">
      <br>Overall:   {{taskResults.overallConditionResult}}&nbsp;&nbsp;<br>
    </div> -->


    <div >
      <br>
      <span>Currently: <b>{{event.evaluateActiveState}}</b></span>
      <span *ngIf="event.evaluateActiveState=='active' && taskResults.overallConditionResult" style="color: #64a70b; float: right">True</span>
      <span *ngIf="event.evaluateActiveState!='active' || !taskResults.overallConditionResult" style="color: #c8102e; float: right">False</span>
      <span style="float: right">Overall: &nbsp;</span>
      &nbsp;&nbsp;
      <br>
    </div>


  </div>
</div>
